/** Pure display helpers for the mapper grid. No React. */

const IMG_EXT_RE = /\.(jpe?g|png|webp|gif|bmp|avif|svg)(\?|#|$)/i;
const IMG_HOST_RE = /(dropboxusercontent\.com|cloudinary\.com|imgix\.net|\.cdn\.|images\.|\/image)/i;

export function isImageUrl(value: string): boolean {
  const v = String(value ?? "").trim();

  if (!/^https?:\/\//i.test(v)) return false;
  if (IMG_EXT_RE.test(v)) return true;
  if (/\.html?(\?|#|$)/i.test(v)) return false;

  return IMG_HOST_RE.test(v);
}

export function truncateForTooltip(
  value: string,
  limit = 500,
): { text: string; truncated: boolean } {
  const v = String(value ?? "");
  const safeLimit = Number.isFinite(limit) ? Math.max(0, Math.floor(limit)) : 500;

  if (v.length <= safeLimit) return { text: v, truncated: false };

  return { text: `${v.slice(0, safeLimit)}…`, truncated: true };
}
